import { useIsFetching, useIsMutating, useQueryClient } from "@tanstack/react-query";
import { useLocation, useParams } from 'react-router-dom';
import { apiRoutes } from "../../../../logic/apiRoutes";
import { LoadingScreen } from "../../LoadingScreen";

export function AccountVerificationTaskStatusIndicator({children}: {children: React.ReactElement}) {
  const { search } = useLocation()
  const { closingId, id } = useParams()
  
  const isSubmitAccountVerificationMutating = useIsMutating([apiRoutes.submitAccountVerification(closingId ?? '', id ?? '', search)])
  const isDeclinePlaidMutating = useIsMutating([apiRoutes.declinePlaid(closingId ?? '', id ?? '', search)])
  const isCreateLinkTokenFetching = useIsFetching([apiRoutes.createLinkToken(closingId ?? '', id ?? '', search)])

  const queryClient = useQueryClient();
  const submitAccountVerificationData = queryClient.getQueryData([apiRoutes.submitAccountVerification(closingId ?? '', id ?? '', search)]);
  const createLinkTokenData = queryClient.getQueryData([apiRoutes.createLinkToken(closingId ?? '', id ?? '', search)]);
  
  //If we already have the data we don't want to shwo the loading screen because it's just a refetch.
  const isLoading =
    (isCreateLinkTokenFetching && !createLinkTokenData) ||
    (isSubmitAccountVerificationMutating && !submitAccountVerificationData) ||
    (isDeclinePlaidMutating);


  if (isLoading) {
    return (
      <LoadingScreen />
    )
  }

  return <>{children}</>
}
